import { useTranslation } from 'react-i18next';

/**
 * Skip Link Component
 * 
 * Provides a hidden link that becomes visible when focused (via Tab key).
 * Allows keyboard users to skip navigation and jump directly to main content.
 * 
 * Usage: Add <SkipLink /> at the top of your page layout, before the header.
 * The target element should have id="main-content".
 */
export default function SkipLink() {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[200] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:shadow-lg"
      data-testid="skip-link"
    >
      {isEnglish ? 'Skip to main content' : 'Siirry pääsisältöön'}
    </a>
  );
}
